import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { announcementsSuccess, announcementsRequest, announcementsFailure } from '../reducers/announcements';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/getAnnouncements/`;

function* announcementsAxios() {

  const state = yield select(fullState => fullState);
  const {
    user: { userId },
    token,
  } = state.loginReducer;
  const response = yield call(() => {

  return axios({
    method: 'get',
    url: API+userId,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      Authorization: `Bearer ${token}`,
    },
    credentials: 'same-origin',
  });
});

  return response;
}

function* workerAnnouncementsSaga() {
  try {
    const response = yield call(announcementsAxios);
    const responseFromAnnouncements= response.data.message[1];
    
    yield put(announcementsSuccess(responseFromAnnouncements));
    if (response.status === 500) {
      yield put(announcementsFailure(responseFromAnnouncements));
    }
  } catch (error) {
     yield put(announcementsFailure(error));
  }
}

export function* watcherAnnouncementsSaga() {
  yield takeLatest(announcementsRequest().type, workerAnnouncementsSaga);
}
